import { NgModule } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { NgbTooltipMfeDocumentDirective } from '@client/mfe/overlay/ngb-tooltip-mfe-document.directive';

@NgModule({
    imports: [
        NgbTooltip,
        NgbTooltipMfeDocumentDirective,
    ],
    exports: [
        NgbTooltip,
        NgbTooltipMfeDocumentDirective,
    ],
})
export class NgbTooltipMfeModule {}
